<!-- App.vue -->

<template>
    <div id="app">
        <Layout />
    </div>
</template>

<script>
import Layout from './components/Layout.vue';

export default {
    components: {
        Layout,
    },
};
</script>

<style>

</style>
